import { create } from 'zustand'

// Не хранит ничего про лидов - просто пробрасывает наружу факт "в этом
// db_chat_id только что было новое входящее сообщение" и его текст. Пишет сюда
// Layout.tsx (у него уже есть единственный WebSocket на всю сессию), читают
// страницы, которым интересен конкретный чат (например LeadChats.tsx),
// сопоставляя chat_id со своим списком.
export interface ChatPreview {
    text: string
    date: string
    // Счётчик события: по нему страница понимает, что пришло новое сообщение,
    // даже если текст совпал с прошлым.
    bump: number
}

interface LeadChatEventsState {
    chatUnreadBumps: Record<number, number>
    chatPreviews: Record<number, ChatPreview>
    bumpChatUnread: (chatId: number, text?: string) => void
    // Диалог проверили на дубль - его строку и шапку нужно перечитать.
    duplicateChecks: Record<number, number>
    bumpDuplicateCheck: (chatId: number) => void
}

export const useLeadChatEventsStore = create<LeadChatEventsState>()((set) => ({
    chatUnreadBumps: {},
    chatPreviews: {},
    duplicateChecks: {},
    bumpDuplicateCheck: (chatId) =>
        set((state) => ({
            duplicateChecks: { ...state.duplicateChecks, [chatId]: (state.duplicateChecks[chatId] || 0) + 1 },
        })),
    bumpChatUnread: (chatId, text) =>
        set((state) => {
            const bump = (state.chatUnreadBumps[chatId] || 0) + 1
            return {
                chatUnreadBumps: { ...state.chatUnreadBumps, [chatId]: bump },
                chatPreviews: {
                    ...state.chatPreviews,
                    [chatId]: { text: text || '', date: new Date().toISOString(), bump },
                },
            }
        }),
}))
